// Stockage simple des tokens côté navigateur (localStorage)
// Centralise les clés & accès pour changer facilement d'implémentation plus tard (IndexedDB, MMKV, etc.)

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'
const EXPIRES_AT_KEY = 'accessTokenExpiresAt' // timestamp (ms) optionnel

function setAccessToken(token: string, expiresInSeconds?: number) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token)
  if (typeof expiresInSeconds === 'number') {
    const expiresAt = Date.now() + expiresInSeconds * 1000
    localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt))
  }
}

function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

function isAccessTokenExpired(earlySkewSeconds = 10): boolean {
  const v = localStorage.getItem(EXPIRES_AT_KEY)
  if (!v) return false // si pas de suivi, on ne bloque pas
  const expiresAt = Number(v)
  return Date.now() >= expiresAt - earlySkewSeconds * 1000
}

function setRefreshToken(token: string) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token)
}

function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
}

export const storageService = {
  setAccessToken,
  getAccessToken,
  isAccessTokenExpired,
  setRefreshToken,
  getRefreshToken,
  clearTokens,
}

export type ThemeState = {
  theme: 'light' | 'dark'
  setTheme: (theme: 'light' | 'dark') => void
  toggleTheme: () => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      setTheme: theme => set({ theme }),
      toggleTheme: () =>
        set({ theme: get().theme === 'light' ? 'dark' : 'light' }),
    }),
    {
      name: 'sphere-theme',
    }
  )
)
